<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-02-01 21:30:29
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">用户列表</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="姓名">
                  <el-input
                    v-model="ruleForm.name"
                    maxlength="50"
                    clearable
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账号状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择账号状态"
                    style="margin-right: auto"
                  >
                    <el-option label="拉黑" value="0"></el-option>
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="已注销" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="身份认证状态">
                  <el-select
                    v-model="ruleForm.cardVerifiedStatus"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="未通过" value="0"></el-option>
                    <el-option label="通过" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="营业执照认证状态">
                  <el-select
                    v-model="ruleForm.businessVerifiedStatus"
                    placeholder="请选择状态"
                    style="margin-right: auto"
                  >
                    <el-option label="未通过" value="0"></el-option>
                    <el-option label="通过" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="客户类型">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.accountType"
                    placeholder="请选择客户类型"
                  >
                    <el-option label="企业" value="0"></el-option>
                    <el-option label="个人" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务省" prop="type1">
                  <el-select
                    v-model="ruleForm.type1"
                    placeholder="请选择"
                    style="margin-right: auto"
                    @change="cityChange"
                  >
                    <el-option
                      v-for="(item, index) in city"
                      :key="item.adcode"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="服务城市"
                  prop="select"
                  v-if="ruleForm.type1 != '100000'"
                >
                  <el-select
                    v-model="ruleForm.select"
                    placeholder="请选择"
                    style="margin-right: auto"
                    @change="cityChange1"
                  >
                    <el-option
                      v-for="(item, index) in city1"
                      :key="item.adcode"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="姓名" align="center" width="130">
            <template slot-scope="scope">
              <span
                >{{ scope.row.name }}<span v-if="scope.row.name != ''">(</span
                >{{ scope.row.phone | maskPhoneNumber }}</span
              >
              <span v-if="scope.row.name != ''">)</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="xwbankStatus"
            label="是否开户"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.xwbankStatus == 0
                  ? "未开户"
                  : scope.row.xwbankStatus == 1
                  ? "已开户"
                  : scope.row.xwbankStatus == 2
                  ? "开户失败"
                  : "审核中"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="jobsTotal"
            label="下单总数"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="failedJobs"
            label="违约次数"
            align="center"
            width="130"
          >
          </el-table-column>
          <el-table-column label="是否保安公司" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.isSecurityCompany == 0 ? "否" : "是" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户类型" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.accountType == 0 ? "企业" : "个人" }}</span>
              <!-- <span v-if="scope.row.accountType == 1">{{
                scope.row.cardVerifiedStatus != 0
                  ? scope.row.accountType == 0
                    ? "企业"
                    : "个人"
                  : "无"
              }}</span>
              <span v-if="scope.row.accountType == 0">{{
                scope.row.businessVerifiedStatus != 0
                  ? scope.row.accountType == 0
                    ? "企业"
                    : "个人"
                  : "无"
              }}</span> -->
            </template>
          </el-table-column>
          <el-table-column label="微信认证" align="center" width="100">
            <template slot-scope="scope">
              <span
                :class="[
                  scope.row.wxVerifiedStatus == 0 ? 'redColor' : 'greenColor',
                ]"
                >{{
                  scope.row.wxVerifiedStatus == 0 ? "未认证" : "已认证"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="认证状态" align="center" width="100">
            <template slot-scope="scope">
              <span
                v-if="scope.row.accountType == 1"
                :class="[
                  scope.row.cardVerifiedStatus == 0 ? 'redColor' : 'greenColor',
                ]"
                >{{
                  scope.row.cardVerifiedStatus == 0 ? "未通过" : "已通过"
                }}</span
              >
              <span
                v-if="scope.row.accountType == 0"
                :class="[
                  scope.row.businessVerifiedStatus == 0
                    ? 'redColor'
                    : 'greenColor',
                ]"
                >{{
                  scope.row.businessVerifiedStatus == 0 ? "未通过" : "已通过"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="账号状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="greenColor" v-if="scope.row.accountStatus == 1"
                >正常</span
              >
              <span class="redColor" v-if="scope.row.accountStatus == 0"
                >拉黑</span
              >
              <span class="redColor" v-if="scope.row.accountStatus == -1"
                >审核失败</span
              >
              <span class="blueColor" v-if="scope.row.accountStatus == -2"
                >待审核</span
              >
              <span class="redColor" v-if="scope.row.accountStatus == 2"
                >已注销</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="lastLoginAddress"
            label="最近登录地址"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginProvince"
            label="最近登录省份"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginCity"
            label="最近登录城市"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginArea"
            label="最近登录地区"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="lastLoginTime"
            label="最近登录时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column label="手机品牌" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.lastPhoneBrand ? scope.row.lastPhoneBrand : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机型号" align="center" width="120">
            <template slot-scope="scope">
              <span>{{
                scope.row.lastPhoneModel ? scope.row.lastPhoneModel : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机系统号" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.lastPhoneSystemVersion
                  ? scope.row.lastPhoneSystemVersion
                  : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前App版本号" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.versionNo ? scope.row.versionNo : "null"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="注册时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="180"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn redColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.accountStatus == 1"
                >
                  禁用
                </div>
                <div
                  class="operateBtn greenColor1"
                  @click="stop(scope.row)"
                  v-if="scope.row.accountStatus == 0"
                >
                  启用
                </div>
                <div class="operateBtn" @click="goDetail(scope.row)">详情</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <TableScrollSlider :table-ref="$refs.scrollTable" />
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import Template from "../template/template.vue";
export default {
  components: {
    system,
    Template,
  },
  data() {
    return {
      leftList: this.Plugins.userData(),
      ruleForm: {
        name: "",
        status: "",
        phone: "",
        identity: "",
        type1: "",
        select: "",
        send: "",
        accountType: "",
        cardVerifiedStatus: "",
        type1: "",
        select: "",
        businessVerifiedStatus: "",
      },
      tableData: [],
      city: [],
      city1: [],
      city2: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
    this.getcity();
  },
  methods: {
    getcity() {
      let param = {
        type: 0,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          let arr = data;
          arr.shift();
          this.city = arr;
          if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "100000") {
            this.getcity1();
          }
        })
        .catch()
        .finally();
    },
    cityChange() {
      if (this.ruleForm.type1 == "100000") {
        this.ruleForm.select = "";
      }
      if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "100000") {
        this.getcity1();
      }
    },
    getcity1() {
      let param = {
        type: 1,
        adcode: this.ruleForm.type1,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city1 = data;
          if (this.ruleForm.select != "") {
            this.getcity2();
          }
        })
        .catch()
        .finally();
    },
    getcity2() {
      let param = {
        type: 2,
        adcode: this.ruleForm.select,
      };
      this.$axios
        .post(`/admapi/city/list`, param)
        .then(({ data }) => {
          this.city2 = data;
        })
        .catch()
        .finally();
    },
    cityChange() {
      if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "0") {
        this.city1 = [];
        this.city2 = [];
        this.ruleForm.select = "";
        this.ruleForm.send = "";
        this.getcity1();
      }
    },
    cityChange1() {
      if (this.ruleForm.type1 != "" && this.ruleForm.type1 != "0") {
        this.ruleForm.send = "";
        this.city2 = [];
        this.getcity2();
      }
    },
    stop(val) {
      this.$confirm(val.accountStatus == 0 ? "是否启用" : "是否禁用", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: val.id,
            state: val.accountStatus == 0 ? 1 : 0,
          };
          this.$axios
            .post(`/admapi/custom/publish`, param)
            .then(({ data }) => {
              this.$message({
                message: val.accountStatus == 0 ? "启用成功" : "禁用成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
    goDetail(val) {
      window.open(
        this.$router.resolve({
          path: "/userDetail",
          query: {
            id: val.id,
          },
        }).href,
        "_blank"
      );
    },
    handleEdit(val) {},
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.accountType = "";
      this.ruleForm.phone = "";
      this.ruleForm.identity = "";
      this.ruleForm.type1 = "";
      this.ruleForm.select = "";
      this.ruleForm.send = "";
      this.ruleForm.businessVerifiedStatus = "";
      this.ruleForm.cardVerifiedStatus = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
      };
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "name",
          type: "input",
          value: this.ruleForm.name,
        });
      }
      if (this.ruleForm.status != "") {
        param.queryParams.push({
          name: "account_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.status }],
        });
      }
      if (this.ruleForm.phone != "") {
        param.queryParams.push({
          name: "phone",
          type: "input",
          value: this.ruleForm.phone,
        });
      }
      if (this.ruleForm.cardVerifiedStatus != "") {
        param.queryParams.push({
          name: "card_verified_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.cardVerifiedStatus }],
        });
      }
      if (this.ruleForm.businessVerifiedStatus != "") {
        param.queryParams.push({
          name: "business_verified_status",
          type: "select",
          values: [{ itemKey: this.ruleForm.businessVerifiedStatus }],
        });
      }
      if (this.ruleForm.type1 != "") {
        param.queryParams.push({
          name: "last_login_province_code",
          type: "select",
          values: [{ itemKey: this.ruleForm.type1 }],
        });
      }
      if (this.ruleForm.select != "") {
        param.queryParams.push({
          name: "last_login_city_code",
          type: "select",
          values: [{ itemKey: this.ruleForm.select }],
        });
      }
      if (this.ruleForm.send != "") {
        param.queryParams.push({
          name: "last_login_area_code",
          type: "select",
          values: [{ itemKey: this.ruleForm.send }],
        });
      }
      if (this.ruleForm.accountType != "") {
        param.queryParams.push({
          name: "account_type",
          type: "select",
          values: [{ itemKey: this.ruleForm.accountType }],
        });
      }
      if (this.ruleForm.select != "") {
        param.queryParams.push({
          name: "last_login_city_code",
          type: "select",
          values: [{ itemKey: this.ruleForm.select }],
        });
      }
      if (this.ruleForm.type1 != "") {
        param.queryParams.push({
          name: "last_login_province_code",
          type: "select",
          values: [{ itemKey: this.ruleForm.type1 }],
        });
      }
      this.$axios
        .post(`/admapi/custom/list`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
</style>
